<section #iconSnackbar class="vsp-icon-snackbar" [ngClass]="{'error': errorMode, 'warning': warningMode }">
  <span #messageContainer>{{message}}</span>
  <a (click)="onIconClick()" [matTooltipPosition]="'right'" matTooltip="Close">
    <mat-icon svgIcon="vsp-icons:closeAlternate"></mat-icon>
  </a>
</section>

<div *ngIf="errorMode" class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"></div>
